import Vue from 'vue';
import VueRouter, { RouteConfig } from 'vue-router';
import CallsByAgentContainer from '../components/CallsByAgent/Container.vue';
import AnalyticsContainer from '../components/Analytics/Container.vue';
import Login from '../views/Login.vue';

Vue.use(VueRouter);

const routes: Array<RouteConfig> = [
    {
        path: '/',
        name: 'Login',
        component: Login,
        meta: { title: () => 'Login' },
    },
    {
        path: '/panel',
        name: 'Panel',
        component: () => import('../views/PanelContainer.vue'),
        meta: { requiresAuth: true, title: () => 'MyFlexPbx' },
        children: [
            {
                path: 'agent',
                name: 'CallsByAgent',
                component: CallsByAgentContainer,
                meta: { requiresAuth: true, title: () => 'Calls By Agent' },
            },
            {
                path: 'analytics',
                name: 'Analytics',
                component: AnalyticsContainer,
                meta: { requiresAuth: true, title: () => 'Analytics' },
            },
            {
                path: 'panorama',
                name: 'GlobalPanorama',
                component: () => import('../views/GlobalPanorama.vue'),
                meta: { requiresAuth: true, title: () => 'Panorama Global' },
            },
            {
                path: 'audit',
                name: 'Audit',
                component: () => import('../views/Audit.vue'),
                meta: { requiresAuth: true, title: () => 'Auditoria' },
            },
            {
                path: 'network',
                name: 'Network',
                component: () => import('../views/Network.vue'),
                meta: { requiresAuth: true, title: () => 'Red' },
            },
        ],
    },
    {
        path: '/unauthorized',
        name: 'Unauthorized',
        component: () => import('../views/Unauthorized.vue'),
        meta: { title: () => 'Unauthorized' },
    },
];

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes,
});

router.afterEach((to) => {
    Vue.nextTick(() => {
        document.title = to.meta.title(to);
    });
});

export default router;
